import Vue from 'vue';
import * as numeral from 'numeral';

Vue.filter('formatNumber', (value: any, numberFormat: string) => {
  return formatNumber(value, numberFormat);
});


export function formatNumber(value: any, numberFormat?: string) : string {
  if (value !== undefined && value !== null) {
    return numeral(value).format(numberFormat ? numberFormat : '0,00.00');
  }

  return '';
}


export function formatDollar(value: any, numberFormat?: string) : string {
  if (value !== undefined && value !== null) {
    return numeral(value).format(numberFormat ? numberFormat : '$0,00.00');
  }

  return '';
}


// WEBPACK FOOTER //
// node_modules/wc-lib/src/wc-converters/number.ts